import React from 'react';
import PropTypes from 'prop-types';
import arrowBack from '../../../assets/Quotes/arrowBack.svg';
import arrowBackHsb from '../../../assets/Quotes/Horizon/arrowBackHsb.svg';
import { isHorizon } from '../../../utils/brandHelper';
import './Buttons.css';

const EditInfoLink = props => {
  const arrowBackImg = isHorizon ? arrowBackHsb : arrowBack;

  return (
    <a
      href={props.route}
      target="_parent"
      className="editInfoBtn d-flex align-items-center justify-content-center"
      onClick={props.handleClick}
    > 
      <img src={arrowBackImg}></img>
      <span>{props.text}</span>
    </a>
  );
};

EditInfoLink.defaultProps = {
  text: 'back'
};

EditInfoLink.propTypes = {
  route: PropTypes.string,
  text: PropTypes.string,
  handleClick: PropTypes.func
};

export default EditInfoLink;
